import { IIconProps } from './add';

export const IcoContinue: React.FC<IIconProps> = ({ cy, style }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-cy={`IcoContinue${cy}`}
    style={style}
  >
    <path
      d="M1.5 7.96387C1.5 6.72637 2.0025 5.60137 2.82 4.78387L1.755 3.71887C0.675 4.80637 0 6.30637 0 7.96387C0 11.0239 2.2875 13.5439 5.25 13.9114V12.3964C3.1275 12.0364 1.5 10.1914 1.5 7.96387ZM12 7.96387C12 4.64887 9.315 1.96387 6 1.96387C5.955 1.96387 5.91 1.97137 5.865 1.97137L6.6825 1.15387L5.625 0.0888672L3 2.71387L5.625 5.33887L6.6825 4.28137L5.8725 3.47137C5.9175 3.47137 5.9625 3.46387 6 3.46387C8.4825 3.46387 10.5 5.48137 10.5 7.96387C10.5 10.1914 8.8725 12.0364 6.75 12.3964V13.9114C9.7125 13.5439 12 11.0239 12 7.96387Z"
      fill="#525A66"
    />
  </svg>
);
